<p-dialog
  *ngIf="visible"
  [(visible)]="visible"
  header="Confirmar Operación {{ message }}"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="flex align-items-center justify-content-center">
    <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
    <span
      >¿Está seguro de que desea {{ message }} del registro seleccionado?</span
    >
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      icon="pi pi-times"
      class="p-button-text"
      label="No"
      (click)="visible = false"
    ></button>
    <button
      pButton
      pRipple
      icon="pi pi-check"
      class="p-button-text"
      label="Si"
      (click)="confirm()"
    ></button>
  </ng-template>
</p-dialog>
